// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthFormButton_container__3AoIr"};